import EBViewPage from "./EBViewPage";

export default EBViewPage;
